<template>
  <el-dialog
    title="执行群聊"
    :visible.sync="showDialog"
    :before-close="cancelAction"
    width="680px"
  >
    <div style="margin-bottom: 15px" />
    <div class="edit-sop">
      <ul class="guize-list">
        <li
          v-for="(item, index) in chatData"
          :key="index"
        >
          <div class="avatar-box">
            <img
              :src="require('@/assets/img/sopavatar.png')"
              width="40px"
            >
          </div>
          <div class="item">
            <h4 class="title">
              {{ item.name }}
            </h4>
            <p class="content">
              群主：<span class="name">{{ item.owner }}</span> 绑定时间：{{ item.bind_time }}
            </p>
          </div>
          <div class="btn-box">
            <el-button
              type="primary"
              size="small"
              @click="sopBindChat(item.chat_id)"
            >
              移除规则
            </el-button>
          </div>
        </li>
      </ul>
    </div>

    <div
      slot="footer"
      class="dialog-footer select-footer"
    >
      <div>
        <!-- <el-pagination
          layout="total, prev, pager, next, jumper"
          @current-change="handleCurrentChange"
          :current-page="params.page"
          :total="total_count"
          :page-size="params.pageSize"
        >
        </el-pagination> -->
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { sopBindChat, getSopDetail } from '@/api/membership/membershipsop'
export default {
  props: {
    sopVisible: {
      // 展示模态框
      type: Boolean,
      default: false
    },
    chatData: {
      type: Array,
      default: () => []
    },
    bindChat: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      key: 1,
      listData: [],
      loading: false,
      bindChats: [],
      multipleSelection: []
    }
  },
  computed: {
    showDialog () {
      return this.sopVisible
    }
  },
  watch: {
    sopVisible (newVal, oldVal) {
      console.log('newVal', newVal)
    },
    chatData (nv, ov) {}
  },
  methods: {
    //移除规则
    async sopBindChat (id) {
      let newChat = []
      newChat = this.bindChat.filter((item) => item != id)
      try {
        const url =
          process.env.VUE_APP_BASE_API + `/salesperson/sop/bind-chat/${this.$route.params.id}`
        this.$http.post(url, { bind_chat: newChat }).then(() => {
          this.$message.success('操作成功')
          this.$emit('closeSopDialog')
          this.$emit('getSopDetail')
        })
      } catch (e) {
        this.$message.success('操作失败')
      }
    },

    // 关闭模态框
    cancelAction () {
      this.$emit('closeSopDialog')
    }
  }
}
</script>

<style lang="scss" scoped>
.guize-list {
  li {
    display: flex;

    justify-content: center;
    border-bottom: 1px solid #f1f1f1;
    padding: 15px 0;
    .avatar-box {
      width: 50px;
    }
    .btn-box {
      width: 100px;
    }
    .item {
      flex: 1;
      font-size: 12px;
      .title {
        color: #333;
      }
      .content {
        color: #666666;
        .name {
          color: #333;
          display: inline-block;
          padding: 10px;
        }
      }
    }
  }
}
</style>
